// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__cyujx","title":"AfterFrontImage_title__13Z8N"};